import { createApi } from "@reduxjs/toolkit/query/react";
import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { ProjectData, ProjectsResponse, ProductTypeResponse, FormData, ProjectWrapper } from "../../models/CreateNewProject";

// interface FormData {
//   priorityStatus: Array<{ id: number; name: string }>;
//   productType: Array<{ id: number; name: string }>;
//   requestType: Array<{ id: number; name: string }>;
//   taskIssuetype: string[];
//   taskStatus: string[];
// }

export const ProjectApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "ProjectApi",
  tagTypes: ['Project'],
  endpoints: (build) => ({
    getFormData: build.query<FormData, void>({
      query: () => {
        return {
          url: 'master-configuration/statuses-and-types',
          method: "GET",
        };
      },
    }),

    createProject: build.mutation<void, ProjectData>({
      query: (projectData) => {
        return {
          url: 'project',
          method: "POST",
          data: projectData,
        };
      },
      invalidatesTags: ['Project'],
    }),

    getProjectData: build.query<ProjectsResponse, { page: number; size: number }>({
      query: ({ page, size }) => {
        return {
          url: `project/all?page=${page}&size=${size}`,
          method: "GET",
        };
      },
      providesTags: ['Project']
    }),

    // getProjectStatusCount: build.query<any, { productTypeIds: any , startDate:any, endDate:any}>({
    //   query: ({ productTypeIds, startDate, endDate }) => {
    //     return {
    //       url: `project/status/counts?productTypeIds=${productTypeIds}&startDate=${startDate}&endDate=${endDate}`,
    //       method: "GET",
    //     };
    //   },
    //   providesTags: ['Project']
    // }),

    getAllProjectData: build.query<ProductTypeResponse, { productTypeIds: number[]; projectStatus: string[]; page: number; size: number, searchTerm: string, startDate: string, endDate: string, priority_status_ids: number[], request_type_ids: number[], userIds: number[] }>({
      query: ({ productTypeIds, projectStatus, page, size, searchTerm, startDate, endDate, priority_status_ids, request_type_ids, userIds }) => {
        return {
          url: `project/projects`,
          method: "POST",
          data: { productTypeIds, projectStatus, page, size, searchTerm, startDate, endDate, priority_status_ids, request_type_ids, userIds },
        };
      },
      // providesTags:['Project']
    }),

    deleteProject: build.mutation<void, number>({
      query: (projectId) => {
        return {
          url: `project?projectId=${projectId}`,
          method: "DELETE",
        }
      },
      invalidatesTags: ['Project'],
    }),

    approveOrDeclineProject: build.mutation<void, { projectId: number; projectStatus: string }>({
      query: ({ projectId, projectStatus }) => ({
        url: `project/${projectId}/approve-decline?projectStatus=${projectStatus}`,
        method: "POST",
      }),
      invalidatesTags: ['Project'],
    }),

    approveEditProject: build.mutation<any, { projectId: number; projectStatus: string; projectWrapper: ProjectWrapper }>({
      query: ({ projectId, projectStatus, projectWrapper }) => ({
        url: `project/${projectId}/edit?projectStatus=${projectStatus}`,
        method: "POST",
        data: projectWrapper,
      }),
    }),

    requestHODApprove: build.mutation<void, number>({
      query: (projectId) => ({
        url: `project/${projectId}/request-approval`,
        method: "POST",
      }),
    }),

    completeProject: build.mutation<void, number>({
      query: (projectId) => ({
        url: `project/${projectId}/complete`,
        method: "POST",
      }),
    }),

  }),

})



export const { useLazyGetFormDataQuery, useCreateProjectMutation, useGetProjectDataQuery, useLazyGetAllProjectDataQuery, useDeleteProjectMutation, useApproveOrDeclineProjectMutation, useApproveEditProjectMutation, useRequestHODApproveMutation, useGetFormDataQuery, useCompleteProjectMutation } = ProjectApi;